var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvgFooterSocialMediaXing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#7FF1AB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0495 18.1364C16.9605 18.3057 15.8026 20.4153 13.5808 24.4753C13.3384 24.9014 13.0464 25.1169 12.705 25.1169H9.48367C9.10266 25.1169 8.88494 24.732 9.06307 24.3778L12.4774 18.1518C12.4873 18.1518 12.4873 18.1466 12.4774 18.1364L10.3051 14.256C10.0923 13.8556 10.3199 13.5322 10.7257 13.5322H13.947C14.3082 13.5322 14.6051 13.7427 14.8377 14.1584L17.0495 18.1364ZM27.9307 9.72372L20.8053 22.7097V22.7251L25.3378 31.2763C25.5308 31.6407 25.3477 32 24.9172 32H21.691C21.3149 32 21.018 31.7947 20.8003 31.3738L16.2281 22.7251C16.3914 22.4274 18.7765 18.0645 23.3932 9.6262C23.6208 9.21044 23.9078 9 24.2591 9H27.5101C27.906 9 28.1188 9.3439 27.9307 9.72372Z",
    fill: "#1C2284"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgFooterSocialMediaXing);
export default __webpack_public_path__ + "static/media/SvgFooterSocialMediaXing.abfde3225e69edfae36b37b46d32566d.svg";
export { ForwardRef as ReactComponent };